
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5a75ff8b&scoped=true!stylus-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./upgradeBlockModal.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./upgradeBlockModal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5a75ff8b!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./upgradeBlockModal.vue"),
  /* scopeId */
  "data-v-5a75ff8b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/upgradeBlockModalViews/upgradeBlockModal.vue
// module id = 2420
// module chunks = 61